// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__29LIN","info":"Note_info__3XrAq","note":"Note_note__2dMI_","actions":"Note_actions__3UGMC"};